<template>
  <div class="filter-result-area">
    <div class="filter-result">
      <div class="skeleton" v-show="isLoading">
        <Skeleton height="20px" width="379px" borderRadius="6px"></Skeleton>
        <Skeleton height="40px" width="525px" borderRadius="6px"></Skeleton>
      </div>
      <div class="filter-result-top-area pagination" v-show="!isLoading">
        <span v-if="searchTextForTemplate"
          >“{{ searchTextForTemplate }}” için {{ totalResultCount }} ürün
          bulundu.</span
        >
        <span v-else>{{ totalResultCount }} ürün bulundu.</span>
        <Pagination
          :pageCount="table.getPageCount()"
          :pageRange="5"
          :clickHandler="clickHandler"
          :firstLastButton="true"
          containerClass="button-group"
          prevLinkClass="border left rounded p-1"
          pageLinkClass="border rounded p-1"
          nextLinkClass="border right rounded p-1"
          :marginPages="0"
          :value="table.getState().pagination.pageIndex"
        ></Pagination>
        <div class="per-page-wrapper">
          <span class="per-page-text">Her Sayfada</span>
          <SimpleSelect
            :simpleSelectItems="paginationOptions.pageSizes"
            :selectedKey="table.getState().pagination.pageSize"
            @btnItemClick="emit('onSimpleSelectChange', $event)"
            class="simpleSelect"
          />
        </div>
      </div>
      <table>
        <tbody>
          <tr
            v-if="isLoading"
            v-for="n in paginationOptions.PRODUCT_CARD_SKELETON_COUNT"
            :key="n"
          >
            <td>
              <ProductCardSkeleton />
            </td>
          </tr>
          <tr v-else v-for="(row, rowIndex) in paginatedRows" :key="row.id">
            <td
              v-for="(cell, cellIndex) in row.getVisibleCells()"
              :key="cell.id"
            >
              <ProductCard
                buttonText="Ürünü Seç"
                :product="cell.row.original"
                :btnLoading="
                  loadingClickedProductId === cell.row.original.pimsId
                "
                :btnDisabled="
                  loadingClickedProductId === cell.row.original.pimsId
                "
                :toolTipText="tooltipText"
                @productCardClick="emit('isOpen', $event)"
                @goToProductPage="goToProductPage(cell.row.original.productGroupId)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="skeleton" v-show="isLoading">
        <Skeleton v-show="isLoading" height="20px" width="379px" borderRadius="6px"></Skeleton>
        <Skeleton v-show="isLoading" height="40px" width="525px" borderRadius="6px"></Skeleton>
      </div>
      <div class="filter-result-top-area pagination" v-show="!isLoading">
        <span v-if="searchTextForTemplate"
          >“{{ searchTextForTemplate }}” için {{ totalResultCount }} ürün
          bulundu.</span
        >
        <span v-else>{{ totalResultCount }} ürün bulundu.</span>
        <Pagination
          :pageCount="table.getPageCount()"
          :pageRange="5"
          :clickHandler="clickHandler"
          :firstLastButton="true"
          containerClass="button-group"
          prevLinkClass="border left rounded p-1"
          pageLinkClass="border rounded p-1"
          nextLinkClass="border right rounded p-1"
          :marginPages="0"
          :value="table.getState().pagination.pageIndex"
        ></Pagination>
        <div class="per-page-wrapper">
          <span class="per-page-text">Her Sayfada</span>
          <SimpleSelect
            :simpleSelectItems="paginationOptions.pageSizes"
            :selectedKey="table.getState().pagination.pageSize"
            openMenuPosition="top-left"
            @btnItemClick="emit('onSimpleSelectChange', $event)"
          />
        </div>
      </div>
    </div>
    <div class="filter-result-bottom">
      <span>Aradığınız ürün n11 kataloğunda yoksa ekleyebilirsiniz.</span>
      <AppButton primary @click="goToAddNewProduct" title="Ürün Ekle" />
    </div>
  </div>
</template>
<script setup>
import Pagination from '@/components/Table/Pagination';
import { AppButton, ProductCard, SimpleSelect, Skeleton } from '@n11/so-ui-components';
import ProductCardSkeleton from '@/components/Skeleton/ProductCardSkeleton'
import { sendProductLinkClickEvent } from '@/utils/ga4/helper';
import { HOST_NAMES } from '@/utils/enum/enviromentHosts';

const emit = defineEmits(["onSimpleSelectChange", "isOpen"]);

const props = defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
  searchTextForTemplate: {
    type: String,
    required: false,
    default: '',
  },
  totalResultCount: {
    type: [String, Number, Object],
    required: true,
  },
  table: {
    type: Object,
    required: true,
  },
  clickHandler: {
    type: Function,
    required: true,
  },
  paginatedRows: {
    type: Object,
    required: true,
  },
  loadingClickedProductId: {
    type: [String, Number, Boolean],
    required: true,
  },
});

const paginationOptions = {
  INITIAL_PAGE_INDEX: 0,
  INITIAL_PAGE_SIZE: 21,
  pageSizes: {
    21: '20 Ürün',
    51: '50 Ürün',
    99: '100 Ürün',
  },
  PRODUCT_CARD_SKELETON_COUNT: 21,
};

const tooltipText = 'Komisyon oranı; mağazanıza, ürün kategorisine ve katıldığınız kampanyalara göre değişiklik gösterir.';

const goToProductPage = (groupIdFromCard) => {
  sendProductLinkClickEvent();

  const currentHostname = window.location.hostname;
  const baseUrl = HOST_NAMES[currentHostname] ?? 'https://www.n11.com';

  const catalogUrl = `${baseUrl}/urun/catalog-`;
  const url = `${catalogUrl}${groupIdFromCard}`;

  window.open(url, '_blank');
};

const goToAddNewProduct = () => {
  window.open('/selleroffice/v2/product/create/single', '_blank');
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.filter-result-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  > div {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: $colorN00;
    justify-content: center;
    align-items: center;
    border-radius: 8px;

    button {
      width: auto;
    }

    span {
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: -0.05px;
      color: $colorN80;
      width: 100%;
    }
  }

  .filter-result {
    padding: 24px;
    background-color: $colorN00;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    span {
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: -0.05px;
      color: $colorN80;
    }

    table {
      width: 100%;
    }

    tbody {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(5, 1fr);
      grid-column-gap: 16px;
      grid-row-gap: 16px;
    }

    &-top-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .pagination-area {
        display: flex;
        gap: 24px;

        > div {
          display: flex;
          gap: 8px;
          align-items: center;

          span {
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            color: $colorN80;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .filter-result-bottom {
    text-align: center;
  }
}

.pagination {
  display: flex;
  width: 50%;
  justify-content: end;
  align-items: center;
  gap: 24px;

  .per-page-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    z-index: 3;

    .per-page-text {
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 16px !important;
      white-space: nowrap !important;
    }
  }

  &.bottom-pagination {
    gap: 24px;
    margin-top: 24px;
  }
}

.skeleton {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
</style>
